




















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GRadioButton',
  props: {
    name: {
      type: String as PropType<string>,
      required: true,
    },
    value: {
      type: Number as PropType<number>,
      required: true,
    },
    checkedValue: {
      type: Number as PropType<number>,
      required: true,
    },
    isFrame: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  computed: {
    innerValue: {
      get(): number {
        return this.value;
      },
      set(val: number): void {
        this.$emit('input', val);
      },
    },
  },
  // methods: {
  //   onChange(e: Event): void {
  //     if (e.target instanceof HTMLInputElement) {
  //       this.$emit('change', Number(e.target.value));
  //     }
  //   },
  // },
});

